<app-permit-common-details [permit]="permit"></app-permit-common-details>

<dl class="row mb-0 mt-2">
    <dt class="col-sm-4">Vehicles</dt>
    <dd class="col-sm-8">{{ permit.vehicleCount ?? '-' }}</dd>

    <!-- Boat-access sites only: how many people, and a photo of the boat. Shown when present. -->
    @if (permit.peopleCount != null) {
        <dt class="col-sm-4">People</dt>
        <dd class="col-sm-8">{{ permit.peopleCount }}</dd>
    }

    @if (permit.boatPhoto) {
        <dt class="col-sm-4">Boat photo</dt>
        <dd class="col-sm-8">
            @if (isImage(permit.boatPhoto)) {
                <a [href]="documentUrl(permit.boatPhoto)" target="_blank" rel="noopener" class="d-block">
                    <img [src]="documentUrl(permit.boatPhoto)" [alt]="permit.boatPhoto.filename || 'Boat photo'" class="uploaded-photo rounded border" loading="lazy" />
                </a>
                <span class="small text-muted">{{ permit.boatPhoto.filename }}</span>
            } @else {
                <a [href]="documentUrl(permit.boatPhoto)" target="_blank" rel="noopener"><i class="fa fa-file me-1"></i>{{ permit.boatPhoto.filename || 'view' }}</a>
            }
        </dd>
    }
</dl>
